export default __webpack_public_path__ + "static/media/10.760dff7f.jpg";